import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { createGTMServiceApi } from './api';
import { GTMServiceApiKey } from './publicApiKey';

export const GTMServiceEntrypoint: EntryPoint = {
  name: 'GTMServiceApi',
  declareAPIs: () => [GTMServiceApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(GTMServiceApiKey, () => createGTMServiceApi(shell));
  },
};
